<template>
    <div class="kdx-ph-apply-school">
        <div class="nav-crumb-top">
            <span>学校申请</span>
        </div>
        <div class="register-step-flow">
            <!-- 填写账号信息 -->
            <div class="register-wrapper">
                <div class="register-main">
                    <div class="mc-register-main">
                        <div class="mc-register-mask clearfix">
                            <el-form ref="registerForm" label-position="top" class="new-register-form-wrappper">
                                <el-form-item label="名称："> <el-input v-model="fromSchoolName" class="input-with-select" placeholder="请输入名称"></el-input><span class="tips-title" style="color:red;margin-left:10px">(全称)</span> </el-form-item>
                                <el-form-item label="别名："> <el-input v-model="fromSchoolAlias" class="input-with-select" placeholder="请输入别名"></el-input><span class="tips-title" style="color:red;margin-left:10px">(历史名称或简称)</span> </el-form-item>
                                <el-form-item label="所属省市：">
                                    <el-select v-model="fromSchoolProvince" class="input-city-select" filterable placeholder="请选择省份" @change="getCityList">
                                        <el-option v-for="item in optionsProvince" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                                    </el-select>
                                    <el-select v-model="fromSchoolCity" class="input-city-select" placeholder="请选择市">
                                        <el-option v-for="item in cityList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="类型：">
                                    <el-select v-model="fromSchoolType" class="input-with-select" filterable placeholder="请选择类型">
                                        <el-option v-for="itemSchoolType in optionsSchoolType" :key="itemSchoolType.value" :label="itemSchoolType.label" :value="itemSchoolType.value"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="申请人姓名：">
                                    <el-input v-model="fromContactsName" class="input-with-select" placeholder="请输入申请人姓名"></el-input>
                                </el-form-item>
                                <el-form-item label="联系方式：" prop="phone" :rules="{ required: true, message: '联系方式不能为空' }">
                                    <el-input v-model="phone"
                                                class="input-with-select"
                                                placeholder="请输入联系方式"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="second-register-next-btn">
                            <el-button type="primary" @click="sure">立即申请</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <p class="p-enter-register clearfix">
                <span class="sp-left" @click="goHome">返回首页</span>
                <span class="sp-right" @click="enterLogin">点击注册</span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            optionsProvince: [],
            fromSchoolCode: "",
            fromSchoolName: "",
            fromSchoolAlias: "",
            fromSchoolProvince: "",
            fromSchoolCity: "",
            fromSchoolType: "",
            fromContactsName: "",
            fromSchoolUrl: "",
            fromContactsPost: "",
            fromContactInformation: "",
            phone: "",
            schoolList: [],
            schoolInfo: [],
            cityList: [],
            optionsSchoolType: [
                {
                    value: "中职",
                    label: "中职",
                },
                {
                    value: "高职",
                    label: "高职",
                },
                {
                    value: "本科",
                    label: "本科",
                },
                {
                    value: "公司",
                    label: "公司",
                },
                {
                    value: "出版社",
                    label: "出版社",
                },
                {
                    value: "其他",
                    label: "其他",
                },
            ],
        };
    },
    created() {
        this.applySchool();
    },
    methods: {
        // 申请学校
        applySchool() {
            this.$http.post("/api/partner/PartnerApplication/getAllProvinceList", {
            }).then(rst => {
                this.optionsProvince = rst.province;
                this.dialogFormVisible = true;
            });
        },
        // 获取城市 省市联动
        getCityList() {
            this.$http
                .post("/api/partner/PartnerApplication/getCityList", {
                    province: this.fromSchoolProvince,
                })
                .then((rst) => {
                    if (rst.code > 0) {
                        this.cityList = rst.cityList;
                    }
                });
        },
        sure() {
            var that = this;
            this.$http
                .post("/api/common/login/applySchool", {
                    SchoolId: this.fromSchoolId,
                    SchoolCode: this.fromSchoolCode,
                    SchoolName: this.fromSchoolName,
                    SchoolAlias: this.fromSchoolAlias,
                    SchoolProvince: this.fromSchoolProvince,
                    SchoolCity: this.fromSchoolCity,
                    SchoolType: this.fromSchoolType,
                    ContactsName: this.fromContactsName,
                    ContactsPost: this.fromContactsPost,
                    ContactInformation: this.fromContactInformation,
                    Salesman: this.fromSalesman,
                    SchoolLogoUrl: this.fromSchoolLogoUrl,
                    SchoolUrl: this.fromSchoolUrl,
                    applyBy: "register",
                    phone: this.phone,
                    shortMessage: this.shortMessage,
                    systemSource: "3",
                })
                .then((rst) => {
                    if (rst.code > 0) {
                        that.cancel();
                        that.$message.success('申请成功！');
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        cancel() {
            this.fromSchoolId = "";
            this.fromSchoolCode = "";
            this.fromSchoolName = "";
            this.fromSchoolAlias = "";
            this.fromSchoolProvince = "";
            this.fromSchoolCity = "";
            this.fromSchoolType = "";
            this.fromContactsName = "";
            this.fromSchoolUrl = "";
            this.fromContactsPost = "";
            this.fromContactInformation = "";
            this.phone = "";
            this.fromSalesman = "";
            this.shortMessage = "";
            this.dialogFormVisible = false;
        },
        goHome() {
            this.$router.push({
                name: "xIndex",
            });
        },
        enterLogin() {
            this.$router.push({
                name: "phRegister",
            });
        },
    },
};
</script>

<style lang="scss">
.kdx-ph-apply-school {
    height: 100%;
    background: #fff;
    overflow: auto;
    padding-bottom: 30px;
    box-sizing: border-box;
    .nav-crumb-top {
        width: 100%;
        line-height: 50px;
        font-size: 20px;
        color: #2d82ff;
        text-align: center;
        border-bottom: 2px solid #2d82ff;
    }
    .register-step-flow {
        width: 100%;
    }
    .register-main {
        width: 100%;
        .register-logo {
            width: 100%;
            text-align: center;
        }
        .mc-register-mask {
            width: 100%;
            .new-register-form-wrappper {
                padding: 20px;
                .el-form-item {
                    margin-bottom: 0;
                }
                .el-form-item__label {
                    line-height: 20px;
                    font-size: 14px;
                    padding: 0;
                }
                .el-select {
                    width: 100%;
                }
                .el-input__inner {
                    width: 100%;
                    background-color: #fff;
                    border: 1px solid #cccccc;
                    color: #666666;
                }

                input::-webkit-input-placeholder {
                    /* WebKit browsers */
                    color: #cccccc;
                }
                input:-moz-placeholder {
                    /* Mozilla Firefox 4 to 18 */
                    color: #cccccc;
                }
                input::-moz-placeholder {
                    /* Mozilla Firefox 19+ */
                    color: #cccccc;
                }
                input:-ms-input-placeholder {
                    /* Internet Explorer 10+ */
                    color: #cccccc;
                }
            }
            .mc-select {
                position: relative;
                .wl-icon-xuexiao {
                    position: absolute;
                    top: 21px;
                    left: 6px;
                    z-index: 1000;
                    color: #c0c4d0;
                }
                .el-select {
                    width: 100%;
                    .el-input {
                        .el-input__inner {
                            padding-left: 30px;
                        }
                    }
                }
            }
            .el-input {
                margin: 10px 0;
            }
            .registerBtn {
                margin: 10px 0;
                width: 100%;
                background-color: #2d82ff;
                color: white;
            }
            .registerInfo {
                margin-top: 10px;
                width: 100%;
                .reCon {
                    float: left;
                    a {
                        color: #2d82ff;
                    }
                }
                .forget-pass {
                    float: right;
                }
            }
            .registerInfo:after {
                content: "";
                height: 0;
                display: block;
                clear: both;
                visibility: hidden;
            }
            .qu-register {
                position: relative;
                margin-top: 40px;
                width: 100%;
                height: 40px;
                div:first-child {
                    margin-top: 10px;
                    width: 100%;
                    height: 0;
                    border-top: 1px solid gray;
                }
                div:last-child {
                    position: absolute;
                    top: -5px;
                    left: 50%;
                    margin-left: -70px;
                    background-color: white;
                    width: 140px;
                    text-align: center;
                    color: gray;
                }
            }
            .wx-register {
                text-align: center;
                color: #2d82ff;
                i {
                    font-size: 40px;
                }
            }
        }
        .register_wx {
            .qu-register {
                position: relative;
                margin-top: 40px;
                width: 100%;
                height: 40px;
                div:first-child {
                    margin-top: 10px;
                    width: 100%;
                    height: 0;
                    border-top: 1px solid gray;
                }
                div:last-child {
                    position: absolute;
                    top: -5px;
                    left: 50%;
                    margin-left: -70px;
                    background-color: white;
                    width: 140px;
                    text-align: center;
                    color: gray;
                }
            }
            .wx-register {
                text-align: center;
                color: #2d82ff;
                i {
                    font-size: 40px;
                }
            }
        }
    }
    .el-form-item__error {
        right: 0;
        left: auto;
    }
    .second-register-next-btn {
        padding: 0 20px;
        .el-button {
            width: 100%;
            background: #2d82ff;
            border-color: #2d82ff;
        }
        .back-to-first {
            margin-top: 10px;
            font-size: 12px;
            color: #2d82ff;
            text-align: right;
            cursor: pointer;
        }
    }
    .p-enter-register {
        margin: 20px;
        color: #2d82ff;
        .sp-left {
            float: left;
        }
        .sp-right {
            float: right;
        }
    }
    .tips-title {
        position: absolute;
        top: -30px;
        right: 0;
        z-index: 2020;
    }
    .input-city-select{
        display: inline-block;
        width: 50%;
    }
}
</style>
